// This code has been partially generated by an AI.

export class TreeNodeDimensions {
  // skill experience stars container dimensions
  readonly starContainerWidth = 70;
  readonly starContainerHeight = 26;
  readonly halfStarContainerHeight = this.starContainerHeight / 2;
  readonly halfStarContainerWidth = this.starContainerWidth / 2;

  // employee count dimensions
  readonly employeeCountContainerWidth = this.starContainerWidth;
  readonly employeeCountContainerHeight = this.starContainerHeight;
  readonly halfEmployeeCountContainerHeight = this.employeeCountContainerHeight / 2;
  readonly halfEmployeeCountContainerWidth = this.employeeCountContainerWidth / 2;
  // Feste Ausmaße des foreignObject: Firefox unterstützt kein overflow: visible auf foreignObject,
  // deshalb muss die aufgeklappte Personenliste vollständig hineinpassen.
  readonly employeeCountListWidth = 500;
  readonly employeeCountListHeight = 460;

  // child skill count dimensions
  readonly lineChildCountConnectorLength = 25;
  readonly childCountContainerWidth = 82;
  readonly childCountContainerHeight = 24;
  readonly childCountContainerBorderRadius = 5;
  readonly childCountContainerPadding = 12;
  readonly plusCircleRadius = 6;
  readonly distanceCircleText = 6;
  readonly fontSize = 12;

  // skill container dimensions
  readonly skillNodeWidth = 200 + 96;
  readonly skillNodeHeight = 80 + 32;
  readonly octagonCornerRadius = 20;
  readonly intraGroupSpacingY = 80;
  readonly intraGroupSpacingX = 40;

  // root values
  readonly rootDimensions = 50;

  // add skill button values
  readonly addSkillRootButtonRadius = 20;

  // centering y value factors
  readonly rootDefaultOffsetYFactor = 0.9;
  readonly nodeFocusOffsetYFactor = 0.5;
}
